<template>
  <div v-if="isActiveSection" class="meetingRoom-container">
    <b-row no-gutters>
      <b-col
        class="meetingRoom-col"
        v-for="meetingRoom in meetingRooms"
        :key="meetingRoom.id"
      >
      <router-link
          :to="{
            name: 'companyProfile',
            params: { companyId: getURL(meetingRoom.company) }
          }"
        >
          <img
            class="meetingRoom-logo"
            :src="meetingRoom.details.logo"
            :alt="meetingRoom.details.name"
          />
          <div class="room-title">
            <p class="title-content">{{ meetingRoom.room }}</p>
          </div>
        </router-link>
      </b-col>
    </b-row>
  </div>
  <div v-else style="text-align: center; color: #BD9D5F">The section is not available now and coming soon...</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import getIDfromURL from '../../../utils/getIDfromURL';

export default {
  name: 'MeetingRooms',
  async mounted() {
    if (this.$route.params.eventId) {
      await this.fetchMeetingRooms(this.$route.params.eventId);
    }
  },
  methods: {
    ...mapActions({
      fetchMeetingRooms: 'events/fetchMeetingRooms',
    }),
    getURL(url) {
      return getIDfromURL(url);
    },
  },
  computed: {
    ...mapGetters({
      meetingRooms: 'events/meetingRooms',
      event: 'events/fetchEvent',
    }),
    isActiveSection() {
      return this.event && this.event.available_sections ? this.event.available_sections.includes('meeting_rooms') : false;
    },
  },
};
</script>

<style scoped>
.meetingRoom-container > .row {
  justify-content: flex-start;
  column-gap: 15px;
}
.meetingRoom-col {
  max-width: 150px;
  min-width: 112px;
  margin: 4px;
  padding: 0;
  background-color: #fff;
  border-radius: 0 10px 10px 10px;
  overflow: hidden;
}
.meetingRoom-col > a {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.meetingRoom-col:hover {
  opacity: 0.6;
  transition: 0.3s;
}
.meetingRoom-logo {
  flex-basis: 150px;
  object-fit: scale-down;
}
.room-title {
  background: #fff;
  color: #BD9D5F;
  width: 100%;
  text-align: center;
  cursor: pointer;
  padding: 8px;
  font-size: 11px;
  border-top: 2px solid #ebebeb;
}
.room-title:hover {
  opacity: 0.5;
  transition: 0.3s;
}
.room-title > p {
  font-size: 11px;
  font-family: Arial;
  line-height: 1.17;
  margin: 0;
}
@media screen and (max-width: 1024px) {
  .meetingRoom-container > .row { 
    justify-content: flex-start;
    column-gap: 8px;
    row-gap: 40px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin: 0 !important;
    padding-bottom: 52px;;
  }
  .meetingRoom-col { 
    position: relative;
    overflow: visible;
    margin-bottom: 35px;
    width: 100%;
    aspect-ratio: 1 / 1 !important;
    padding: 3px !important;
    margin: 0 !important;
  }

  .meetingRoom-col a {
    height: 100%;
  }

  .room-title {
    position: absolute;
    bottom: -30px;
    left: 0;
  }
  .title-content {
    display: inline-block;
    vertical-align: middle;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
